export const DEFAULT_COOKIE_EXPIRES_SECONDS = {
	session: 0,
	middleDay: 12 * 60 * 60, // 43200 segundos = 12 horas
	oneDay: 24 * 60 * 60, // 86400 segundos = 1 dia
	oneWeek: 7 * 24 * 60 * 60, // 604800 segundos = 7 dias
	oneMonth: 30 * 24 * 60 * 60, // 2592000 segundos = 30 dias
	threeMonths: 90 * 24 * 60 * 60, // 7776000 segundos = 90 dias
	oneYear: 365 * 24 * 60 * 60, // 31536000 segundos = 365 dias
} as const;

/**
 * Define um cookie com o nome, valor e opções especificadas.
 * @param name - Nome do cookie.
 * @param value - Valor do cookie.
 * @param options - Opções adicionais (ex: expires, path, secure).
 */
export function setCookie(
	name: string,
	value: string,
	options: {
		expires?: Date | number;
		path?: string;
		secure?: boolean;
		sameSite?: "Strict" | "Lax" | "None";
	} = {},
) {
	let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

	if (options.expires)
		if (typeof options.expires === "number") {
			const date = new Date();
			date.setTime(date.getTime() + options.expires * 1000);
			cookieString += `; expires=${date.toUTCString()}`;
		} else cookieString += `; expires=${options.expires.toUTCString()}`;

	if (options.path) cookieString += `; path=${options.path}`;
	if (options.secure) cookieString += "; secure";
	if (options.sameSite) cookieString += `; samesite=${options.sameSite}`;

	document.cookie = cookieString;
}

/**
 * Obtém o valor de um cookie pelo nome.
 * @param name - Nome do cookie.
 * @returns O valor do cookie ou undefined se não encontrado.
 */
export function getCookie(name: string): string | undefined {
	const nameEQ = `${encodeURIComponent(name)}=`;
	const cookies = document.cookie.split(";");

	for (const cookie of cookies) {
		const trimmed = cookie.trim();
		if (trimmed.startsWith(nameEQ)) return decodeURIComponent(trimmed.substring(nameEQ.length));
	}
	return undefined;
}

/**
 * Remove um cookie definindo sua expiração para uma data passada.
 * @param name - Nome do cookie.
 * @param path - Caminho do cookie (opcional, padrão '/').
 */
export function removeCookie(name: string, path = "/") {
	setCookie(name, "", { expires: new Date(0), path });
}
